/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../../lib/@waca/core-client/js/core-client/utils/BidiUtil',
	'../../../dashboard/util/TextEditor',
	'../../../app/util/LocaleUtil',
	'../../../app/nls/StringResources',
	'jquery',
	'underscore'
], function (View, BidiUtil, TextEditor, LocaleUtil, resources, $, _) {

	var localizedProp = function (str) {
		if (typeof str === 'object') {
			var locale = document.getElementsByTagName('html')[0].getAttribute('lang');
			return (str[locale] || str.en || str[Object.keys(str)[0]]);
		}
		return str;
	};

	var WidgetTitleView = View.extend({

		init: function (options) {
			this.titleId = options.id + 'Title';
			this.canEditTitle = options.canEditTitle;
			this.widgetModel = options.widgetModel;
			this.widgetChromeEventRouter = options.widgetChromeEventRouter;
			this.header = options.header;
			this.dashboardApi = options.dashboardApi;
			this.registerEvents();
		},

		registerEvents: function () {
			this.widgetChromeEventRouter.on('title:chromeSelected', this.onChromeSelected, this);
			this.widgetChromeEventRouter.on('title:chromeDeselected', this.onChromeDeselected, this);
			this.widgetChromeEventRouter.on('title:containerReady', this.onContainerReady, this);
			this.widgetChromeEventRouter.on('title:enterContainer', this.onEnterContainer, this);
			this.widgetChromeEventRouter.on('title:updateModel', this.updateModelContent, this);
			this.widgetChromeEventRouter.on('widget:clearWidgetArialabel', this.clearWidgetArialabel, this);
			this.widgetChromeEventRouter.on('widget:updateWidgetArialabel', this.updateWidgetArialabel, this);
			if (this._isTitleModeEnabled()) {
				this.widgetModel.on('change:titleMode', this._showTitle, this);
			} else {
				this.widgetModel.on('change:showTitle', this._showTitle, this);
			}
		},

		/**
		 * Based on properties, generate the HTML for the static content
		 */
		getHtmlRender: function () {
			return this.getStyleNode().get(0).outerHTML;
		},

		_getTextProperties: function(text) {
			return {
				style: 'responsive',
				text: text
			};
		},

		/**
		 * Render widget title view
		 * @param {boolean} [hidden=false] whether to render hidden or not
		 */
		render: function (hidden = false) {
			let titleHtml;
			let title = '';
			if(this.widgetModel && this.widgetModel.get) {
				titleHtml = TextEditor.cleanContentElements(this.widgetModel.get('titleHtml'));
				title = this.widgetModel.get('name');
			}
			var sTitle = title ? localizedProp(title) : '';

			if (titleHtml) {
				this.$el = $(titleHtml);
				if(!this.$el.length) {
					this.$el = $(`<div class="widgetTitle" title="${sTitle}">${titleHtml}</div>`);
				}
				this._nTitle = this.$el.find('.textArea');
			} else {
				this.$el = $('<div>', {
					'class': 'widgetTitle',
					'title': sTitle
				});

				this.$el.attr('aria-labelledby', this.titleId);

				this._nTitle = $('<div>', {
					'class': 'textArea'
				});

				this.$el.prepend(this._nTitle);
			}
			this.$el.attr('walkme-data-id', 'widgetTitle');
			this.$el.toggleClass('titleShown', !!(sTitle && sTitle.length));
			const shouldShowTitle = this._shouldShowTitle();
			this._nTitle.toggleClass('hidden', hidden && !shouldShowTitle);
		},

		remove: function() {
			this.widgetChromeEventRouter.off('title:chromeSelected', this.onChromeSelected, this);
			this.widgetChromeEventRouter.off('title:chromeDeselected', this.onChromeDeselected, this);
			this.widgetChromeEventRouter.off('title:containerReady', this.onContainerReady, this);
			this.widgetChromeEventRouter.off('title:enterContainer', this.onEnterContainer, this);
			this.widgetChromeEventRouter.off('title:updateModel', this.updateModelContent, this);
			this.widgetChromeEventRouter.off('widget:clearWidgetArialabel', this.clearWidgetArialabel, this);
			this.widgetChromeEventRouter.off('widget:updateWidgetArialabel', this.updateWidgetArialabel, this);
			if (this._isTitleModeEnabled()) {
				this.widgetModel.off('change:titleMode', this._showTitle, this);
			} else {
				this.widgetModel.off('change:showTitle', this._showTitle, this);
			}
			this.widgetModel.off('change:titleHtml', this._onTitleHtmlChange, this);

			if (this.textEditor) {
				this.textEditor.destroy();
				this.textEditor = null;
			}
			WidgetTitleView.inherited('remove', this, arguments);
		},

		onContainerReady: function (widget) {

			const truncateFeature = widget && widget.content && widget.content.getFeature && widget.content.getFeature('WidgetTitleTruncate');
			const extension = truncateFeature && truncateFeature.getExtensionHooks();
			truncateFeature && truncateFeature.setUpdateModelContent( this.updateModelContent.bind(this));
			truncateFeature && truncateFeature.setTitleHighlighter( this._highlightTitle.bind(this));

			this._handleEditUpdateTruncation = extension && extension.onEditUpdate;

			// TODO: Revisit how this class is implemented.
			// There could be a chance that some of the functions in the class are called before onContainerReady,
			// causing a null exception when accessing 'this.textEditor'. (e.g. updateTitle())
			// For now, we check for this.textEditor === null all over this class to make sure when don't blow up.
			this.widget = widget;
			this.textEditor = new TextEditor({
				'node': this._nTitle,
				'container': this.header,
				'widget': widget,
				'fontSizes': TextEditor.INT_FONTSIZE_CHOICES,
				'toolbarNode': widget.$widgetContainer,
				'shouldResizeViz': true,
				'initialState': {
					'fontSize': '16',
					'color': 'responsiveColor'
				},
				'extension' : extension
			});
			if (LocaleUtil.isLocaleRTL()) {
				BidiUtil.initElementForBidi(this._nTitle);
			}
			//Widget title is never responsive (Removed auto size)
			this.textEditor.isResponsive = false;
			this.widgetModel.on('change:titleHtml', this._onTitleHtmlChange, this);
			this.textEditor.initContentEditable('p');
			this.textEditor.selectionBindNodeEvents();

			this._applyTitle();
			this._updateAriaInfo();

			// register the textEditor as a properties provider for text format properties
			return this.dashboardApi.getCanvasWhenReady().then((canvas) => {
				const content = canvas.getContent(widget.id);
				content.getFeature('Properties').registerProvider(this.textEditor);
				content.getFeature('TextEditor').registerProvider({
					'widgetId': widget.id,
					'textEditor': this.textEditor,
					'titleId': this.titleId
				});
			});
		},

		_updateAriaInfo: function() {
			const titleNodeId = this.widgetModel.id + 'Title';
			this.$el.find('.note-editable').attr('id', titleNodeId);
		},

		_onTitleHtmlChange: function(options) {
			options = options || {};
			if( options && ( options.value === null || options.value === '' || options.value === undefined) ) {
				this._setTitleHtmlFromName();
			} else {
				if(this.textEditor){
					const appliedContentResult = this.textEditor.applyContent(options);
					const title = this.textEditor.getTitleFromHtml(this.getHtmlRender());
					this.$el.prop('title', title); //update title, so tooltip is also synced
					return appliedContentResult;
				}

			}
		},

		_applyTitle: function() {
			if(!this.textEditor) {
				return;
			}
			const translationService = this.dashboardApi.getFeature('TranslationService');
			if (!this.widgetModel.get('name')) {

				//when the smart title feature is enabled and the user is in the custom title
				let addPlaceHolder = true;
				if (this._isTitleModeEnabled()) {
					const titleMode = this.widget && this.widget.content && this.widget.content.getPropertyValue('titleMode');
					addPlaceHolder = titleMode && titleMode === 'customTitle';
				}

				if (this.canEditTitle && addPlaceHolder) {
					let prop = this._getTextProperties(resources.get('titlePlaceHolder'));
					this.textEditor.setText(TextEditor.getTextHTML(prop));
					this._isTitleModeEnabled() && this.textEditor.toggleEditing(true);
				} else {
					this.textEditor.setText(' ');
				}
			} else if (!this.widgetModel.get('titleHtml')) {

				//Special case for upgraded dashboard.
				if (this.widgetModel['name'] && this.widgetModel['name'].translationTable) {
					//update all the locales
					_.each(this.widgetModel['name'].translationTable, (item, locale) => {
						//update the locale
						this.widgetModel.set({ 'name' : { locale: locale, value: item } });
						this._setTitleHtmlFromName(locale);
					});
				}

				//and ensure our html is reset to the default locale.
				this._setTitleHtmlFromName();

			} else if(translationService.isInTranslationMode()) {
				this._updateTextEditor();
			}
		},

		/**
		 * Set the HTML for a specific name properly using the provided locale (or Default if locale is null)
		 * This is storing HTML directly in the spec. This is not ideal to say the least.
		 */
		_setTitleHtmlFromName: function(locale) {
			if(!this.textEditor) {
				return;
			}
			let prop = this._updateTextEditor(locale);
			//update the aria labels
			if (prop.text) {
				this.$el.prop('title', prop.text);
				this.$el.find('.ariaLabelNode').html(TextEditor.cleanContentElements(prop.text));
			}

			let updatedHtml = TextEditor.cleanContentElements(this.getHtmlRender());

			//Get the default language if ant
			const boardModel = this.dashboardApi.getFeature('internal').getBoardModel();
			let titleOptions = boardModel.getLanguageModelOptions();
			_.extend(titleOptions, {
				silent: true
			});

			this.widgetModel.set(
				{ titleHtml: { value: updatedHtml, locale: locale } },
				titleOptions
			);

		},

		_updateTextEditor: function(locale) {
			let _propValue = this.widgetModel.get('name');

			//get the localized value of the name
			if (locale && this.widgetModel['name']) {
				_propValue = this.widgetModel['name'].getValue(locale);
			}
			let prop = this._getTextProperties(_propValue);
			const _textHTML = TextEditor.getTextHTML(prop);
			this.textEditor.setText(_textHTML);

			//update so smart title updates don't confuse text editor into thinking edit happened and it needs to save
			this.textEditor.updateLastSavedText(_textHTML);

			return prop;
		},

		_showTitle: function (options) {
			this.updateTitle(options);

			//only toggleEdit (highlights all title text) when needed - if smart title is disabled or when its enabled and we are changing
			//from noTitle to customTitle
			let showTitle = this.widgetModel.showTitle;
			const titleMode = this.widget.content.getPropertyValue('titleMode');
			if(!showTitle  && titleMode === 'customTitle') {
				if( options && options.prevValue === 'noTitle') {
					showTitle = true;
				} else {
					showTitle = false;
				}
			}
			if (this.canEditTitle && showTitle ) {
				if (this.textEditor && this.widget && this.widget.chromeSelected && this.widget.isAuthoringMode) {
					this.textEditor.toggleEditing(!(options && options.data && options.data.edit === false), options);
				}
			}
		},

		_hasHeader: function() {
			if (this.widget && this.widget.$el && this.widget.$el.parent() && this.widget.$el.parent().find) {
				return this.widget.$el.parent().find('.widgetHeader').length !== 0;
			}
			return false;
		},

		_toggleEdit: function(toggle) {
			if (!this.textEditor) {
				return;
			}

			if(this.textEditor.isEditing() && this.textEditor.textIsEmpty() && toggle === false){
				if (this._isTitleModeEnabled()) {
					this.widget.content.setPropertyValue('titleMode', 'noTitle');
				} else {
					this.widget.content.setPropertyValue('showTitle', false);
				}
			}

			this.textEditor.toggleEditing(toggle);
		},

		checkAndRecreateHeader: function () {
			if (!this.widget) {
				return;
			}
			if (this.widget.isWidgetMaximized && this.widget.isWidgetMaximized()) {
				return;
			}
			if (!this._hasHeader()) {
				this.widgetChromeEventRouter.trigger('title:resetTitle', {
					widgetTitleView: this
				});
			}
		},

		/**
		 *
		 * @returns true when titleMode is defined and not set to 'noTitle' or showTitle is set (for backward compatibility)
		 */
		_shouldShowTitle: function() {
			if (this._isTitleModeEnabled()) {
				if(this.widgetModel.titleMode === undefined) {
					return !!this.widgetModel.showTitle;
				}
				const titleMode = this.widgetModel.titleMode || 'smartTitle';
				return titleMode !== 'noTitle';
			} else {
				return !!this.widgetModel.showTitle;
			}
		},

		_isWidgetReady: function() {
			let widgetReady = true;

			if (this._isTitleModeEnabled()) {
				const visualization = this.widget && this.widget.content && this.widget.content.getFeature('Visualization');
				if(visualization && visualization.getSlots() && visualization.getSlots().isMappingComplete() === false) {
					widgetReady = false;
				}
			}

			return widgetReady;
		},

		updateTitle: function (options) {
			const widgetReady = this._isWidgetReady();
			const shouldShowTitle = this._shouldShowTitle() && widgetReady;
			const wasShowingTitle = !this._nTitle.hasClass('hidden');

			if (shouldShowTitle) {
				this.checkAndRecreateHeader();
				this._applyTitle();
				this._nTitle.removeClass('hidden');
			} else {
				this._nTitle.addClass('hidden');
				if (this.textEditor){
					this.textEditor.toggleEditing(false, options);
				}
			}

			if(shouldShowTitle !== wasShowingTitle) {
				this.widgetChromeEventRouter.trigger('title:resizeViz');
			}
		},

		onChromeSelected: function () {
			WidgetTitleView.inherited('onChromeSelected', this, arguments);
			if(this.textEditor && this.canEditTitle) {
				this.textEditor.attachEnterEditEvents();
			}
		},

		onChromeDeselected: function () {
			WidgetTitleView.inherited('onChromeDeselected', this, arguments);
			this._toggleEdit(false);
			if (this.textEditor) {
				this.textEditor.detachEnterEditEvents();
			}
		},

		onChromeOffFocus: function () {
			this._toggleEdit(false);
		},

		getProperties: function (properties) {
			return this.textEditor.getProperties(properties);
		},

		onEnterContainer: function () {
			if(this.textEditor && this.canEditTitle) {
				this.textEditor.toggleEditing(true);
			}
		},

		/**
		 * Updates the model version of the markup of this widget
		 * @param updatedHtml An optional parameter of the markup.
		 *		This is to avoid regenerating the markup if it is already known.
		*/
		updateModelContent: function (info) {
			if(!this.textEditor){
				return;
			}

			// update the model to persist the changes. Use transactionId to combine undos
			const boardModel = this.dashboardApi.getFeature('internal').getBoardModel();
			var data = boardModel.getLanguageModelOptions();

			if (info.transactionId) {
				_.extend(data, {
					payloadData: {
						undoRedoTransactionId: info.transactionId,
						transactionToken: info.transactionToken
					}
				});
			} else {
				_.extend(data, {
					silent: true
				});
			}


			//SMEditTest
			const title = this.textEditor.getTitleFromHtml(this.getHtmlRender());

			let existingTitle = null;
			if(this.widgetModel && this.widgetModel.get) {
				existingTitle = this.widgetModel.get('name');
			}
			let sExistingTitle = existingTitle ? localizedProp(existingTitle) : '';

			this.$el.prop('title', title); //update title, so tooltip is also synced

			const updatedHtml = TextEditor.cleanContentElements(this.getHtmlRender());

			this._handleEditUpdateTruncation && this._handleEditUpdateTruncation(sExistingTitle, updatedHtml, title, info.transactionId);

			//SMEditTest

			this.widgetModel.set({
				titleHtml: updatedHtml,
				name: title
			}, data);
		},


		//only used in the context of  edit Title action - in some cases, we just need to highlight the title
		_highlightTitle: function() {
			this.textEditor.toggleEditing(true);
		},

		updateWidgetArialabel: function (event) {
			if (this._nAriaLabel) {
				this._nAriaLabel.text(event.value);
			}
		},

		clearWidgetArialabel: function () {
			if (this._nAriaLabel) {
				this._nAriaLabel.empty();
			}
		},

		getStyleNode: function () {
			return this.$el;
		},

		/**
		 * IMPORTANT:
		 *   - checks the smartTile setting in order to decide whether or not titleMode is enabled
		 *   - check dashboardSettings for unit test purpose
		 * @returns {boolean} true if titleMode is on, false otherwise
		 */
		_isTitleModeEnabled: function() {
			const dashboardSettings = this.dashboardApi.getFeature('DashboardSettings');
			let isEnabled = false;
			if (dashboardSettings) {
				const applicationSettings = dashboardSettings.get('applicationSettings');
				isEnabled = applicationSettings
							&& applicationSettings.options
							&& applicationSettings.options.config
							&& applicationSettings.options.config.smartTitle === true;
			}
			return isEnabled;
		}
	});
	return WidgetTitleView;
});
